let language = {
    PRICE_LIST_TITLE: "Tiered Price Table",
    PRICE_LIST_LINK: "FlexiBulk Savings Program",
    PRICE_LIST_QTY_TEXT: "Qty",
    PRICE_LIST_US_COUNTRY_TEXT: "US",
    PRICE_LIST_OTHER_AREA_TEXT: "Others",
    PRICE_LIST_PRICE_TEXT: "Price"
};

export { language }